import React, { useContext, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { Flex } from "@olist/design-system";

import { ProductItem } from "components/product-item";
import { MixpanelContext } from "contexts";
import {
  AiImg,
  ContaImg,
  CreditIcon,
  ErpImg,
  LojaImg,
  OlistEnviosImg,
} from "icons/index";

export function Products() {
  const { trackAgent } = useContext(MixpanelContext);
  const navigate = useNavigate();

  document.title = "Central de ajuda";

  const products = [
    {
      image: <AiImg />,
      title: "Agentes de IA",
      description:
        "Aumente a sua produtividade, melhorando sua rotina, permitindo que você consiga focar no que realmente importa: seus resultados. Tudo isso através de ferramentas de Inteligência Artificial da Olist.",
      onClick: () => {
        trackAgent.track("Central de ajuda - Agentes de IA", {
          asset: "Central de ajuda",
          page: "products",
          product: "Agentes de IA",
          clickedOn: "Saiba Mais",
        });
        navigate("/kb/articles/agentes-de-ia");
      },
    },
    {
      image: <ErpImg />,
      title: "ERP",
      description:
        "Automatize tarefas, reduza erros e economize tempo. Aqui, você encontra orientações sobre cada funcionalidade e soluções para suas dúvidas.",
      onClick: () => {
        trackAgent.track("Central de ajuda - ERP", {
          asset: "Central de ajuda",
          page: "products",
          product: "ERP",
          clickedOn: "Saiba Mais",
        });
        navigate("/kb/articles/erp");
      },
    },
    {
      image: <CreditIcon />,
      title: "Crédito",
      description:
        "Antecipe seus boletos de forma 100% online e rápida. Dinheiro na conta da sua empresa sem complicação.",
      onClick: () => {
        trackAgent.track("Central de ajuda - Crédito", {
          asset: "Central de ajuda",
          page: "products",
          product: "Crédito",
          clickedOn: "Saiba Mais",
        });
        navigate("/kb/articles/credito");
      },
    },
    {
      image: <ContaImg />,
      title: "Conta Digital",
      description:
        "Emita boletos, faça transferências e pague com PIX diretamente no ERP da Olist. Aqui, você encontre tudo o que precisa saber sobre esses recursos.",
      onClick: () => {
        trackAgent.track("Central de ajuda - Conta Digital", {
          asset: "Central de ajuda",
          page: "products",
          product: "Conta Digital",
          clickedOn: "Saiba Mais",
        });
        navigate("/kb/articles/conta-digital");
      },
    },
    {
      image: <OlistEnviosImg />,
      title: "Envios",
      description:
        "Aproveite opções de frete com preços baixos e coleta de pacotes grátis. Aqui, você descobre  como tornar seus envios ainda mais eficientes.",
      onClick: () => {
        trackAgent.track("Central de ajuda - Envios", {
          asset: "Central de ajuda",
          page: "products",
          product: "Envios",
          clickedOn: "Saiba Mais",
        });
        navigate("/kb/articles/envios");
      },
    },
    {
      image: <LojaImg />,
      title: "Loja",
      description:
        "A solução completa para dominar os marketplaces do Brasil. Aqui, você encontra respostas rápidas e o guia definitivo para o seu sucesso na Olist.",
      onClick: () => {
        trackAgent.track("Central de ajuda - Loja", {
          asset: "Central de ajuda",
          page: "products",
          product: "Loja",
          clickedOn: "Saiba Mais",
        });
        navigate("/kb/articles/loja");
      },
    },
  ];

  useEffect(() => {
    trackAgent.track("Central de ajuda", {
      asset: "Central de ajuda",
      page: "products",
    });
  }, []);

  return (
    <Flex
      justifyContent="flex-start"
      alignItems="center"
      gap="24px"
      flexWrap="wrap"
    >
      {products.map((product) => (
        <ProductItem key={product.title} {...product} />
      ))}
    </Flex>
  );
}
